import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-htcli',
  templateUrl: './htcli.component.html',
  styleUrls: ['./htcli.component.scss']
})
export class HtcliComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
